import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Skeleton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLUMN_HEADERS, COLUMN_WIDTHS } from './columnConfig';

const StyledTableContainer = styled(TableContainer)(() => ({
    height: '100%',
    overflow: 'auto',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(4),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));

export const RelevanceTestDefinitionSearchResultsSkeleton = (): JSX.Element => {
    const skeletonRows = Array.from({ length: 5 }, (_, i) => i);

    return (
        <StyledTableContainer>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="center" width={COLUMN_WIDTHS.searchTerm}>{COLUMN_HEADERS.searchTerm}</StyledTableCell>
                        <StyledTableCell align="center" width={COLUMN_WIDTHS.gallery}>{COLUMN_HEADERS.gallery}</StyledTableCell>
                        <StyledTableCell align="center" width={COLUMN_WIDTHS.culture}>{COLUMN_HEADERS.culture}</StyledTableCell>
                        <StyledTableCell align="center" width={COLUMN_WIDTHS.sampleSize}>{COLUMN_HEADERS.sampleSize}</StyledTableCell>
                        <StyledTableCell align="center" width={COLUMN_WIDTHS.scoredEntities}>{COLUMN_HEADERS.scoredEntities}</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {skeletonRows.map((index) => (
                        <TableRow key={`skeleton-${index}`}>
                            <StyledTableCell align="center" width={COLUMN_WIDTHS.searchTerm}><Skeleton animation="wave" /></StyledTableCell>
                            <StyledTableCell align="center" width={COLUMN_WIDTHS.gallery}><Skeleton animation="wave" /></StyledTableCell>
                            <StyledTableCell align="center" width={COLUMN_WIDTHS.culture}><Skeleton animation="wave" /></StyledTableCell>
                            <StyledTableCell align="center" width={COLUMN_WIDTHS.sampleSize}><Skeleton animation="wave" /></StyledTableCell>
                            <StyledTableCell align="center" width={COLUMN_WIDTHS.scoredEntities}><Skeleton animation="wave" /></StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};
